// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__XDzQg","sm":"Toggle_sm__ipsUH","lg":"Toggle_lg__i_NIP","slider":"Toggle_slider__5iOJP"};